export { PLUGIN_NAME as PluginName } from "./shared";
export type { IEsbuildOption } from "./EsbuildPlugin";
